import React from 'react'
import ReactDOM from 'react-dom'
import { runWithAdal } from 'react-adal'
import { AuthenticationContext } from 'react-adal'
import axios from 'axios'

const adalConfig = {
  tenant: localStorage.getItem('REACT_APP_ADAL_TENANTID'),
  clientId: localStorage.getItem('REACT_APP_ADAL_CLIENTID'),
  redirectUri: window.location.protocol + '//' + window.location.host,
  endpoints: { api: 'https://graph.microsoft.com' },
  cacheLocation: 'localStorage',
  postLogoutRedirectUri: 'https://tssands.com/'
}

export const authContext = new AuthenticationContext(adalConfig)

const getTokenAsync = () => {
  return new Promise((resolve, reject) => {
    authContext.acquireToken(authContext.config.clientId, (error, token) => {
      if (error) {
        reject(error)
      } else {
        resolve(token)
      }
    })
  })
}

const setupAxiosInterceptor = () => {
  axios.interceptors.request.use(
    async config => {
      try {
        let token = authContext.getCachedToken(authContext.config.clientId)
        
        if (!token) {
          try {
            token = await getTokenAsync()
          } catch (error) {
            console.warn('Could not acquire token for request:', error)
          }
        }
        
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      } catch (error) {
        console.error('Error adding auth token to request:', error)
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config
      
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true
        
        try {
          const newToken = await getTokenAsync()
          originalRequest.headers.Authorization = `Bearer ${newToken}`
          return axios(originalRequest)
        } catch (tokenError) {
          console.error('Token refresh failed after 401:', tokenError)
          if (!window.location.href.includes('login')) {
            authContext.login()
          }
        }
      }
      
      return Promise.reject(error)
    }
  )
}

const setupTokenRefresh = () => {
  setInterval(async () => {
    try {
      await getTokenAsync()
    } catch (error) {
      console.warn('Periodic token refresh failed:', error)
    }
  }, 45 * 60 * 1000)
  
  window.addEventListener('focus', async () => {
    try {
      await getTokenAsync()
    } catch (error) {
      console.warn('Token refresh on focus failed:', error)
    }
  })
}

export const start = () => {
  const { App } = require('./App')

  setupAxiosInterceptor()
  setupTokenRefresh()

  runWithAdal(
    authContext,
    () => ReactDOM.render(<App />, document.getElementById('root')),
    false //DO_NOT_LOGIN
  )
}